import Vuex from 'vuex';
import Vue from 'vue';
import actions from './actions';
import mutations from './mutations';
import state from './state';
import getters from './getters';
import ShareLabStore from '../Views/ShareLab/store'

Vue.use(Vuex)
export default new Vuex.Store({
    actions,
    mutations,
    state,
    getters,
    modules: {
        ShareLabStore
    }
})


// WEBPACK FOOTER //
// ./src/vuex/index.js